export default __webpack_public_path__ + "static/hram-prepodobnogo-sergiya-radonezhskogo_1-2d25f167eff5ae9aa8bd7b77b6865f63.jpg";